module.exports = __webpack_public_path__ + "public/img/logo1.41a81543.png";